// A set `points` value always renders as a single point. Only animator questions
// have multiple selectable options (and `points` is null for them); for video/image
// pointsOptions is an internal "editable during evaluation" sentinel and must NOT be
// shown as options. Pure + isolated so the gating can be regression-tested directly.
export const getPointsDisplayMode = (
  points?: number | null,
  pointsOptions?: number[] | null,
): 'none' | 'single' | 'multiple' => {
  if (points) {
    return 'single';
  }
  if (pointsOptions?.length) {
    return 'multiple';
  }
  return 'none';
};
